// this component was automatically generated by IconGlyph.template.js
import React from 'react';
import { TestId } from '@trello/test-ids';

import { Icon, IconColor, IconSize } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon. Usually it
   * matches up with the display name of the icon
   * @default If no label is provided, it will fallback to the name of the icon
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default @icon-default-color (#42526E)
   */
  color?: IconColor;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-test-id) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
}

const StarIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.495 20.995L12 18.627l4.505 2.368a1.546 1.546 0 002.244-1.63l-.86-5.016 3.644-3.553a1.546 1.546 0 00-.857-2.638l-5.037-.732-2.252-4.564a1.547 1.547 0 00-2.774 0L8.361 7.426l-5.037.732a1.546 1.546 0 00-.857 2.638l3.645 3.553-.86 5.016a1.547 1.547 0 002.243 1.63zm11.85-10.947l-3.672 3.58.867 5.056L12 16.297l-4.54 2.387.867-5.055-3.673-3.58L9.73 9.31 12 4.71l2.27 4.6 5.076.738z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StarIcon: React.FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label } = props;
  return (
    <Icon
      testId={testId}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      label={label || 'StarIcon'}
      glyph={StarIconGlyph}
    />
  );
};
